import cn from 'classnames';
import type { FC } from 'react';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectItemSource } from '@src/reducers/product';

import styles from './styles.module.scss';

interface ICommonInformationProps {
    className?: string;
}

export const CommonInformation: FC<ICommonInformationProps> = memo(({ className }) => {
    const { organization } = useSelector(selectItemSource) || {};

    const data = useMemo(
        () =>
            organization
                ? [
                      {
                          name: 'Полное наименование',
                          value: organization.nameOfficial,
                      },
                      {
                          name: 'Год основания',
                          value: `В государственный реестр МФО внесена в ${new Date(
                              organization.registrationDate,
                          ).getFullYear()} году`,
                      },
                      {
                          name: 'Руководство',
                          value: organization.contacts?.leadership,
                      },
                      {
                          name: 'Деятельность компании',
                          value: organization.description,
                      },
                      {
                          name: '№ регистрации',
                          value: organization.license === '0' ? '' : organization.license,
                      },
                  ].filter((item) => !!item.value)
                : [],
        [organization],
    );

    if (!organization) {
        return null;
    }

    return (
        <div className={cn(styles.container, className)}>
            <div className={styles.common_info}>
                <h2 className={styles.title}>Общая информация о МФО &laquo;{organization.name}&raquo;</h2>
                <div className={styles.content}>
                    {data.map(({ name, value }) => (
                        <div className={styles.row} key={name}>
                            <div className={cn(styles.base_cell, styles.name_cell)}>{name}</div>
                            <div className={styles.base_cell} dangerouslySetInnerHTML={{ __html: value }} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});
